module.exports = __webpack_public_path__ + "img/banner2.c576b954.png";